/**
 * Represents the type of permission assigned to a grant.
 */
export enum PermissionEnum {

	TrackShipments,

	QuoteShipments,

	BookQuotes

}